<template>
  <section class="troop-assign">
    <h3 class="troop-title">Troop Assignment</h3>
    <p v-if="subtitle" class="drag-hint">{{ subtitle }}</p>
    <div v-for="row in troopSliderRows" :key="row.slug" class="troop-slider">
      <div class="label-row">
        <span>
          <i :class="row.icon" :style="{ color: row.color }"></i>
          {{ row.name }}
        </span>
        <span class="stock-val">{{ row.qty }} / {{ row.max }}</span>
      </div>
      <div class="slider-row">
        <input
          type="range"
          min="0"
          :max="row.max"
          step="1"
          :value="row.qty"
          :disabled="row.max < 1"
          @input="setTroopQty(row.slug, $event.target.value)"
        />
        <input
          class="qty-input"
          type="number"
          min="0"
          :max="row.max"
          :value="row.qty"
          :disabled="row.max < 1"
          @input="setTroopQty(row.slug, $event.target.value)"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import { useGameStore } from "../store/game";
import { UNIT_SLUGS, unitDisplayMap } from "../utils/unitDisplay";

const props = defineProps({
  questSlug: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: "",
  },
});

const gameStore = useGameStore();

const troopSliderRows = computed(() => {
  const slug = props.questSlug;
  if (!slug) return [];
  const remaining = gameStore.remainingUnitsForQuest(slug);
  const assigned = gameStore.assignmentForQuest(slug).assigned_troops || {};
  return UNIT_SLUGS.map((unitSlug) => {
    const display = unitDisplayMap[unitSlug] || {
      name: unitSlug,
      icon: "fas fa-users",
      color: "#d8d0c0",
    };
    const qty = Math.max(0, Math.floor(Number(assigned[unitSlug]) || 0));
    const max = Math.floor(Number(remaining[unitSlug]) || 0);
    return {
      slug: unitSlug,
      name: display.name,
      icon: display.icon,
      color: display.color,
      qty,
      max,
    };
  });
});

const setTroopQty = (unitSlug, value) => {
  if (!props.questSlug) return;
  gameStore.setQuestTroopQty(props.questSlug, unitSlug, value);
};
</script>

<style scoped>
.troop-assign {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 246, 255, 0.15);
}

.troop-title {
  margin: 0 0 8px;
  font-size: 0.95rem;
  color: #9bc4ff;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.drag-hint {
  text-align: center;
  color: #8892b0;
  font-size: 0.8rem;
  margin: 0 0 16px;
}

.troop-slider {
  margin-bottom: 12px;
}

.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  font-size: 0.85rem;
  color: #d8d0c0;
}

.label-row i {
  margin-right: 6px;
}

.stock-val {
  font-family: monospace;
  color: #00f0ff;
  font-size: 0.8rem;
}

.slider-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.slider-row input[type="range"] {
  flex: 1;
  cursor: pointer;
  accent-color: #00f0ff;
}

.qty-input {
  width: 4.25rem;
  padding: 0.3rem 0.4rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 246, 255, 0.35);
  background: rgba(8, 12, 24, 0.85);
  color: #00f0ff;
  font-family: monospace;
  font-size: 0.95rem;
  text-align: right;
}
</style>
